import React from 'react';
import SessionSalesContent from './SessionSalesContent';

const SessionSales = () => <SessionSalesContent />;

export default SessionSales;
